import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "linear-gradient(to right, rgba(147, 5, 46, 1), rgba(204, 0, 51, 1)" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify